import { createContext } from "react";

export interface FeaturesShowcaseModalContextType {
  open: (isAutoShowConfetti?: boolean) => void;
  close: () => void;
  isOpen: boolean;
  autoShowConfetti: boolean;
}

export const FeaturesShowcaseModalContext =
  createContext<FeaturesShowcaseModalContextType | null>(null);
